import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Register Firebase Service Worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Firebase Service Worker registered with scope: ', registration.scope);
    })
    .catch((error) => {
      console.error('Firebase Service Worker registration failed: ', error);
    });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
